import { render, staticRenderFns } from "./RecordOfTableReplacement.vue?vue&type=template&id=13ee9849&scoped=true"
import script from "./RecordOfTableReplacement.vue?vue&type=script&lang=js"
export * from "./RecordOfTableReplacement.vue?vue&type=script&lang=js"
import style0 from "./RecordOfTableReplacement.vue?vue&type=style&index=0&id=13ee9849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee9849",
  null
  
)

export default component.exports